import { Component, OnInit } from '@angular/core';
import { MembersSearchFiltersService } from '../../services/members-search-filters.service';

@Component({
  selector: 'app-members-filters-component',
  templateUrl: './members-filters-component.component.html',
  styleUrls: ['./members-filters-component.component.scss']
})
export class MembersFiltersComponent implements OnInit {

  constructor(public filter_service: MembersSearchFiltersService) {
  }

  ngOnInit() {
  }

}
